import useForm from 'hooks/useForm';
export default function usePlaylistDomainsForm() {
  return useForm({
    fields: {
      domainsToAdd: {
        getDefaultValue: function getDefaultValue() {
          return [];
        }
      },
      domainsToRemove: {
        getDefaultValue: function getDefaultValue() {
          return [];
        }
      }
    }
  });
}